import { render, staticRenderFns } from "./NovelDetailEdit.vue?vue&type=template&id=168a52e0&scoped=true"
import script from "./NovelDetailEdit.vue?vue&type=script&lang=ts"
export * from "./NovelDetailEdit.vue?vue&type=script&lang=ts"
import style0 from "./NovelDetailEdit.vue?vue&type=style&index=0&id=168a52e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168a52e0",
  null
  
)

export default component.exports